import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Auth from "./index";
import ApiSession from "../../api/index";
import { useMantineColorScheme } from "@mantine/core";
import SEConfirmModal from "../common/SEConfirmModal";

const auth = new Auth();
const AuthCallback = () => {
  const navigate = useNavigate();
  const { toggleColorScheme } = useMantineColorScheme();

  const [loading, setLoading] = React.useState(true);
  const [showSubscriptionModal, setShowSubscriptionModal] = React.useState(false);
  const [subscriptionMessage, setSubscriptionMessage] = React.useState("");
  const [showUserNotFoundModal, setShowUserNotFoundModal] = React.useState(false);

  useEffect(() => {
    const handleAuthentication = async () => {
      try {
        await auth.handleAuthentication();

        const apiSession = new ApiSession();

        apiSession.getScope().then((response) => {
          setLoading(false);
          const scopeList = {};

          const scopeListAccess = {};

          scopeList.role = response.role;
          scopeList.name = response.name;
          scopeList.email = response.email;
          scopeList.subscriptionEndDate = response.subscriptionEndDate;
          

          response?.scope?.forEach((scopeData) => {
            scopeListAccess[scopeData] = true;
          });

          scopeList.access = scopeListAccess;

          // Set default dark mode
          localStorage.setItem("mantine-color-scheme", "dark");
          toggleColorScheme();
          localStorage.setItem("scope", JSON.stringify(scopeList));
          navigate(response.firstLogin ? "/TermsAndConditions" :  "/dashboard");
        })
        .catch((error) => {
          if (error?.response !== undefined && error?.response?.status === 402) {
            // Show modal with subscription expired message
            const data = error?.response?.data;
            setSubscriptionMessage(
              `${data?.message}: ${data?.httpCodeMessage ? `${data.httpCodeMessage}` : ""}. Please contact Administrator.`
            );
            setShowSubscriptionModal(true);
            setLoading(false);
            return;
          }
          else if(error?.response !== undefined && error?.response?.status === 404){ setLoading(false);
          setShowUserNotFoundModal(true);
          return;
          }
        });
      } catch (error) {
        if (error?.response !== undefined && error?.response?.status === 404) {
          navigate("/dashboard");
        }
      }
    };

    handleAuthentication();
  }, [navigate]);
  return (
    <>
      <se-loading loading={loading}></se-loading>
      {showSubscriptionModal && (
        <SEConfirmModal
          opened={showSubscriptionModal}
          header="Alert"
          onlyOk
          message={subscriptionMessage}
          onClose={() => {
            setShowSubscriptionModal(false);
            navigate("/");
          }}
          confirmLabel="OK"
        />
      )}
      {showUserNotFoundModal && (
        <SEConfirmModal
          opened={showUserNotFoundModal}
          header="Alert"
          onlyOk
          message={"You do not have access to this Application.</br>Please, contact MGA Support or your Administrator."}
          onClose={() => {
            setShowUserNotFoundModal(false);
            navigate("/");
          }}
          confirmLabel="OK"
        />
      )}
    </>
  );
};

export default AuthCallback;
